module.exports = __webpack_public_path__ + "img/icon5.5a16e762.png";